import { CustomHeaderPolicy } from "./CustomHeaderPolicy";
export const TENANT_HEADER = 'x-tenant-context';
export function createTenantPolicy(tenant) {
  return {
    create: (nextPolicy, options) => new CustomHeaderPolicy(nextPolicy, options, TENANT_HEADER, tenant)
  };
}
//# sourceMappingURL=createTenantPolicy.js.map